import { LabelProps, Label } from './Label';
export function LabelDisplay4(props: LabelProps) {
    return (
        <Label
            color="text-dark-red"
            variant="text-mobile-display-4"
            {...props}
        />
    );
}
